import { types } from 'mobx-state-tree';
import { NewsFeedBaseModel } from './base.model';

export const NewsFeedTelephonogramModel = types.compose(
  'NewsFeedTelephonogram',
  NewsFeedBaseModel,
  types.model({
    type: types.literal('telephonogram'),
    telephonogramType: types.optional(
      types.enumeration(['administration', 'gzhi', 'rsu', 'info'] as const),
      'info'
    ),
  })
);
